import { TableCell, Typography } from '@mui/material';
import { getSelectorAttribute, invoicesOverviewPageSelectors } from '@vy/app-selectors';

type ShareInvoicesTableCellProps = {
  text: React.ReactNode;
};

export const ShareInvoicesTableCell: React.FC<ShareInvoicesTableCellProps> = ({ text }) => {
  return (
    <TableCell
      sx={{
        paddingX: '0px',
      }}
    >
      <Typography
        variant="body1"
        {...getSelectorAttribute(invoicesOverviewPageSelectors.shareInvoiceDialog.tableCells)}
        sx={{
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "24px",
          color: "text.primary"
        }}>
        {text}
      </Typography>
    </TableCell>
  );
};
